<template>
  <div id="app">
    <div v-if="show" class="contain">
      <transition name="slide-fade">
        <router-view></router-view>
      </transition>
      <transition name="fade">
        <div class="warning-box" v-if="showAlert">
          <div class="warning-content">
            <div class="warning-content-title">提醒</div>
            <div class="warning-content-msg">{{message}}</div>
            <div class="warning-content-btn">
              <div class="warning-confirm button" @click="confirm">确认</div>
            </div>
          </div>
        </div>
      </transition>
    </div>
    <div v-if="!show" class="lowVer">浏览器版本过低，请先升级浏览器</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'App',
  data () {
    return {
      show: false,
      showAlert: false
    }
  },
  computed: {
    ...mapGetters([
      'message'
    ])
  },
  watch: {
    $route (to, from) {
      this.$cookies.set('routePath', to.fullPath)
    },
    message: function (val) {
      if (val) {
        console.log(val)
        this.showAlert = true
      }
    }
  },
  created () {
    this.$router.push({
      path: this.$cookies.get('routePath')
    })
    var userAgent = navigator.userAgent // 取得浏览器的userAgent字符串
    var isIE = userAgent.indexOf('compatible') > -1 && userAgent.indexOf('MSIE') > -1 // 判断是否IE<11浏览器
    var isEdge = userAgent.indexOf('Edge') > -1 && !isIE // 判断是否IE的Edge浏览器
    var isIE11 = userAgent.indexOf('Trident') > -1 && userAgent.indexOf('rv:11.0') > -1
    if (isIE) {
      var reIE = new RegExp('MSIE (\\d+\\.\\d+);')
      reIE.test(userAgent)
      var fIEVersion = parseFloat(RegExp['$1'])
      if (fIEVersion < 10) {
        console.log('当前浏览器版本过低，请先升级浏览器。')
      } else {
        this.show = true
      }
    } else if (isEdge) {
      console.log('edge')
      this.show = true
    } else if (isIE11) {
      console.log('11')
      this.show = true
    } else {
      // console.log('不是IE浏览器')
      this.show = true
    }
  },
  methods: {
    confirm: function () {
      this.$store.dispatch('changeMessage', '')
      this.$router.push({path: '/'})
      this.showAlert = false
    }
  }
}
</script>

<style>
  #app{
    height: 100%;
    width: 100%;
    background-color: #101431;
  }
  .contain {
    font-family: MicrosoftYaHei,serif !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    width: 100%;
    height: 100%;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue